import { HttpClient } from '@angular/common/http';
import { SharedService } from '../_shared/shared.service';
import { Injectable } from '@angular/core';
import { Product } from './models/products.models';
import { BehaviorSubject } from 'rxjs';

@Injectable({
	providedIn: 'root',
})
export class ProductsService extends SharedService {
	constructor(http: HttpClient) {
		super(http);
	}

	getProductsList() {
		return this._http.get<any>(`${this.api}/products/list`);
	}

	getProduct(id: number) {
		return this._http.get<any>(`${this.api}/products/${id}`);
	}

	getProductWithParticipants(id: number) {
		return this._http.get<any>(`${this.api}/products/full/${id}`);
	}

	requestTinyUrl(id: number) {
		return this._http.post<any>(`${this.api}/products/generateTinyUrl`, id);
	}

	saveProduct(p: Product) {
		if (p.CedrSystem === 'EDJOIN') {
			p.CategoryId = 9;
		} else {
			p.IsSjcoeItem = true;
			p.CategoryId = 8;
		}
		return this._http.post<any>(`${this.api}/products/${p.Id}`, p);
	}

	deleteProduct(id: number) {
		return this._http.delete<any>(`${this.api}/products/${id}`);
	}

	copyToClipboardUtil(doc: Document, content: string) {
		if (content != null) {
			// Pulled out of clipboard.js
			doc.createElement('textarea');
			const /** @type {?} */ isRTL =
				doc.documentElement.getAttribute('dir') === 'rtl';
			let /** @type {?} */ ta;
			ta = doc.createElement('textarea');
			// Prevent zooming on iOS
			ta.style.fontSize = '12pt';
			// Reset box model
			ta.style.border = '0';
			ta.style.padding = '0';
			ta.style.margin = '0';
			// Move element out of screen horizontally
			ta.style.position = 'absolute';
			ta.style[isRTL ? 'right' : 'left'] = '-9999px';
			// Move element to the same position vertically
			const /** @type {?} */ yPosition =
				window.pageYOffset || doc.documentElement.scrollTop;
			ta.style.top = yPosition + 'px';
			ta.setAttribute('readonly', '');
			doc.body.appendChild(ta);
			ta.value = content;
			ta.select();
			ta.setSelectionRange(0, ta.value.length);
			doc.execCommand('copy');
			// document.removeChild(ta);
			return true;
		} else {
			return false;
		}
	}

	initiateCustomTransactionReport(startDate: string, weeks: number) {
		return this._http.get<any>(`${this.api}/transactions/log/report/csv?startDate=${startDate}&weeks=${weeks}`);
	}

	getCategories() {
		return ['SJCOE', 'EDJOIN', 'CONFERENCE'];
	}
}

export const productWatchService = new class {
	public readonly productImage = new BehaviorSubject('');
	public readonly productTitle = new BehaviorSubject('');
	changeProductImage(img: string) {
		this.productImage.next(img);
	}
	changeProductTitle(title: string) {
		this.productTitle.next(title);
	}
}();
